import Axios from "axios";
var DemandService = (function () {
    function DemandService() {
    }
    DemandService.prototype.getDemandDetail = function (demandId) {
        return Axios.get("supplierclientapi/demand/detail", { params: { business_demand_id: demandId } });
    };
    DemandService.prototype.getMemberRights = function (params) {
        return Axios.get("supplierclientapi/member/get_config", { params: params });
    };
    DemandService.prototype.createSingleOrder = function (data) {
        return Axios.get("supplierclientapi/demand/buy_demand", { params: data });
    };
    DemandService.prototype.rechargeVip = function (data) {
        return Axios.post("supplierclientapi/member/recharge", data);
    };
    DemandService.prototype.getIosMiniStatus = function (params) {
        return Axios.post("supplierclientapi/get_ios_mini_status", params || {});
    };
    DemandService.prototype.getUserInfo = function (params) {
        return Axios.get("business/get_wx_user_info", { params: params });
    };
    DemandService.prototype.getMiniProgramQRCode = function (params) {
        return Axios.get("supplierclientapi/demand/get_mp_qrcode", { params: params });
    };
    DemandService.createInstance = function () {
        DemandService.getInstance();
    };
    DemandService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return DemandService;
}());
export default DemandService;
